const LK_ArrowUp =({color,width,height})=>{
    return(
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill={color} viewBox="0 0 116.99 116.99">
            {/* <defs>
                <style>
                .cls-1 {
                    fill: #005c8e;
                    stroke-width: 0px;
                }
                </style>
            </defs> */}
            <path class="cls-1" d="M108.32,90.75L60.8,27.39c-.55-.73-1.39-1.16-2.31-1.16s-1.76.42-2.31,1.16L8.67,90.75h99.65M116.99,95.08H0S52.72,24.79,52.72,24.79c1.44-1.93,3.61-2.89,5.78-2.89s4.33.96,5.78,2.89l52.72,70.29h0Z"/>
        </svg>
    );
};

export default LK_ArrowUp;